/** One HTTP write per click, including edited retries after a lost response.
 * The server receipt owns the entity version; it rejects delayed older revisions
 * and any retry after another editor has changed the record. */
export class CreationAttempt<T> {
  private pending: { key: string; payload: string; revision: number } | undefined

  reset() {
    this.pending = undefined
  }

  async run<R>(payload: T, send: (payload: T, key: string, revision: number) => Promise<R>) {
    const serialized = JSON.stringify(payload)
    this.pending ??= { key: crypto.randomUUID(), payload: serialized, revision: 0 }
    if (serialized !== this.pending.payload) {
      this.pending.payload = serialized
      this.pending.revision++
    }
    // Never discard a key on an ambiguous outcome or silently adopt a newer
    // entity version. Reopening the form is the explicit conflict resolution.
    return send(payload, this.pending.key, this.pending.revision)
  }
}
